import { render } from "./EditPayment.vue?vue&type=template&id=1e21596a"
import script from "./EditPayment.vue?vue&type=script&lang=js"
export * from "./EditPayment.vue?vue&type=script&lang=js"

import "./EditPayment.vue?vue&type=style&index=0&id=1e21596a&lang=css"

import exportComponent from "C:\\Users\\Admin\\NodeProjects\\FibreFrontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__